import { z } from 'zod';
import { languageZodEnum } from '../../enum';

export const requestEnrollMailReqDto = z.object({
  email: z.string().email(),
  language: languageZodEnum(),
  source: z.string().optional(),
});
export type RequestEnrollMailReqDto = z.infer<typeof requestEnrollMailReqDto>;
